import React from 'react';
import {
  Box,
  TextField,
  Chip,
  Button,
  Typography,
  InputAdornment,
  Skeleton,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const GoalSearchSection = ({
  goalsSearchTerm,
  onSearchChange,
  displayedGoals,
  filteredGoals,
  goalsExpanded,
  onToggleExpanded,
  selectedGoals,
  onGoalToggle,
  originalGoalIds,
  isLoadingStudentGoalsData,
}) => {
  const restrictedSelectedGoals = selectedGoals.filter(
    (goal) => goal.isRestricted
  );
  const displayedGoalIds = new Set(displayedGoals.map((goal) => goal.id));
  const combinedGoals = [
    ...displayedGoals,
    ...restrictedSelectedGoals.filter((goal) => !displayedGoalIds.has(goal.id)),
  ];

  return (
    <Box sx={{ p: 3, minHeight: '200px' }}>
      <TextField
        fullWidth
        placeholder='Search goals...'
        value={goalsSearchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{ mb: 2 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />

      {isLoadingStudentGoalsData ? (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
          {[120, 140, 100, 160, 110, 130, 150, 90].map((width, index) => (
            <Skeleton
              key={index}
              variant='rectangular'
              animation='pulse'
              sx={{
                borderRadius: '16px',
                height: 32,
                width: `${width}px`,
              }}
            />
          ))}
        </Box>
      ) : displayedGoals.length === 0 ? (
        <Typography
          variant='body2'
          color='text.secondary'
          sx={{ textAlign: 'center', py: 3 }}
        >
          {goalsSearchTerm
            ? 'No goals found matching your search.'
            : 'No goals available for this student.'}
        </Typography>
      ) : (
        <>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
            {combinedGoals.map((goal) => {
              const isSelected = selectedGoals.some((g) => g.id === goal.id);
              return (
                <Chip
                  key={goal.id}
                  label={goal.title}
                  onClick={() => onGoalToggle(goal)}
                  disabled={
                    originalGoalIds?.includes(goal.id) || goal.isRestricted
                  }
                  sx={{
                    fontFamily: 'Lato, sans-serif',
                    cursor: 'pointer',
                    backgroundColor: isSelected ? '#9291f0' : '#e0e0e0',
                    color: isSelected ? 'white' : 'rgba(0, 0, 0, 0.87)',
                    '&:hover': {
                      backgroundColor: isSelected ? '#7a79d1' : '#d5d5d5',
                    },
                  }}
                />
              );
            })}
          </Box>

          {filteredGoals.length > 10 && (
            <Button
              onClick={onToggleExpanded}
              endIcon={goalsExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              sx={{
                textTransform: 'none',
                fontFamily: 'Lato, sans-serif',
                color: '#9291ef',
              }}
            >
              {goalsExpanded
                ? 'Show Less'
                : `Show ${filteredGoals.length - 10} More`}
            </Button>
          )}
        </>
      )}
    </Box>
  );
};

export default GoalSearchSection;

